import { render, staticRenderFns } from "./ShareholderInfo.vue?vue&type=template&id=7f423ff3&scoped=true"
import script from "./ShareholderInfo.vue?vue&type=script&lang=js"
export * from "./ShareholderInfo.vue?vue&type=script&lang=js"
import style0 from "./ShareholderInfo.vue?vue&type=style&index=0&id=7f423ff3&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f423ff3",
  null
  
)

export default component.exports